import { BlockProps, IBlockLocation } from '../../content-blocks/type';
import { WebsiteBlockProps } from './type';

interface Props {
  key: string;
  label: string;
  location: IBlockLocation;
}

export const createWebsiteBlock = (props: Props): WebsiteBlockProps => {
  return {
    type: 'website',
    value: props.label,
    width: 20,
    height: 20,
    isVisible: false,
    x: 0,
    y: 0,
    fontSize: 12,
    isBold: false,
    isItalics: false,
    isCapsLocks: false,
    ...props,
  };
};

export function isWebsiteBlock(block: BlockProps): block is WebsiteBlockProps {
  return block.type === 'website';
}
